/* eslint-disable array-callback-return, default-case  */

import { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  CreditCardLineItem,
  VoucherLineItem,
  PointsLineItem,
  CreditNoteLineItem,
  ChargesLineItem,
  QantasTravelPassLineItem,
} from './lineItems';
import BreakdownHeading from '../BreakdownHeading';
import * as propTypes from '../../propTypes';

const RefundBreakdown = ({ breakdown, penalty, showHeading, titleStyle, itemStyle }) => (
  <Fragment>
    {showHeading && <BreakdownHeading>REFUND</BreakdownHeading>}
    {breakdown.map((breakdownItem) => {
      const { method } = breakdownItem;
      switch (method) {
        case 'credit_card':
          return <CreditCardLineItem key={method} {...breakdownItem} titleStyle={titleStyle} itemStyle={itemStyle} />;
        case 'voucher':
          return <VoucherLineItem key={method} {...breakdownItem} titleStyle={titleStyle} itemStyle={itemStyle} />;
        case 'points':
          return <PointsLineItem key={method} {...breakdownItem} titleStyle={titleStyle} itemStyle={itemStyle} />;
        case 'credit_note':
          return <CreditNoteLineItem key={method} {...breakdownItem} titleStyle={titleStyle} itemStyle={itemStyle} />;
        case 'qantas_group_credit_voucher':
          return <QantasTravelPassLineItem key={method} {...breakdownItem} titleStyle={titleStyle} itemStyle={itemStyle} />;
      }
    })}

    {penalty.length > 0 && (
      <Fragment>
        <BreakdownHeading mt={4}>CHARGES</BreakdownHeading>
        <ChargesLineItem penalty={penalty} />
      </Fragment>
    )}
  </Fragment>
);

RefundBreakdown.defaultProps = {
  showHeading: true,
  titleStyle: {},
  itemStyle: {},
};

RefundBreakdown.propTypes = {
  showHeading: PropTypes.bool,
  breakdown: PropTypes.arrayOf(propTypes.paymentBreakdownItem).isRequired,
  penalty: ChargesLineItem.propTypes.penalty,
  titleStyle: PropTypes.object,
  itemStyle: PropTypes.object,
};

export default RefundBreakdown;
